import { markRaw } from 'vue'
import CatalogsService from 'src/services/catalogs'

export default {
  fetchAll (payload) {
    this.status = 'loading'
    const promise = CatalogsService.fetchAll(payload)

    promise.then(data => {
      this.catalogs = markRaw(data.data)
      this.status = 'success'
    })
      .catch(() => {
        this.status = 'error'
      })

    return promise
  },
  remove (catalogId) {
    this.catalogs = markRaw(this.catalogs.filter(catalog => catalog.id !== catalogId))
  },
  fetchElements (payload) {
    const promise = CatalogsService.fetchCalimaxElements(payload.id, payload)

    promise.then(data => {
      this.catalog = data
    })

    return promise
  },
  deleteElements () {
    this.catalog = null
  },
  fetchCatalog (catalogId) {
    return CatalogsService.fetch(catalogId)
  },
  searchCatalogElements (catalogId, payload) {
    return CatalogsService.searchElements(catalogId, payload)
  }
}
